import request from 'utils/request'

export const getRelationList = data => {
  return request().post('outward/query', data)
}

// download导出
export const download = data =>
  request().post('outward/export', data, {
    responseType: 'blob',
  })
